import React from 'react';
import './Badge.css';

/*
 * Badge — the mock's `.pill`. Small uppercase pill with a leading dot.
 *   variant : 'in' | 'out' | 'denied' | 'accident' | 'auth' | 'neutral'
 *             (default 'neutral' -> the mock's .pill--plain: no dot, not uppercased)
 *   dot     : override whether the leading dot shows (defaults on for event
 *             variants, off for neutral)
 *
 * Convenience: pass an event type string ('IN'/'OUT'/'DENIED'/'ACCIDENT',
 * or 'LOGIN'/'LOGOUT') as `type` and the variant + label are derived.
 */
const VARIANT_CLASS = {
  in: 'pill--in',
  out: 'pill--out',
  denied: 'pill--denied',
  accident: 'pill--accident',
  auth: 'pill--auth',
  neutral: 'pill--plain',
};

// maps a raw GateType label -> badge variant
const TYPE_TO_VARIANT = {
  IN: 'in',
  OUT: 'out',
  DENIED: 'denied',
  ACCIDENT: 'accident',
  LOGIN: 'auth',
  LOGOUT: 'auth',
};

export default function Badge({
  variant,
  type,
  dot,
  className = '',
  children,
  ...rest
}) {
  const resolved = variant || (type ? TYPE_TO_VARIANT[String(type).toUpperCase()] : 'neutral') || 'neutral';
  const showDot = dot != null ? dot : resolved !== 'neutral';
  const cls = [
    'pill',
    VARIANT_CLASS[resolved] || 'pill--plain',
    showDot ? '' : 'pill--nodot',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={cls} {...rest}>
      {children != null ? children : type}
    </span>
  );
}
